<template>
  <div class="dorm-tab__left mycursorPointer">
    <div v-on:click="goPageAll()"
      :to="{ name: 'Person', params: { slug: this.$route.params.slug } }"
      v-if="$route.params.type || $route.params.faculty" class="dorm-tab__button">
      <span class="button__wrp">
        <span class="dorm-tab__txt">
          See<literal> All</literal>
        </span>
      </span>
    </div>
    <div v-on:click="goPage(tab)"
      class="dorm-tab__button mycursorPointer"
      v-for="tab in tabs2" :key="tab.id"
      :class="[{ active : tab.typeID === checkGender }, tab.cat ]">
        <span class="button__wrp">
          <span class="dorm-tab__icon">
            <img :src="tab.icon" alt="" class="icon">
          </span>
          <span class="dorm-tab__txt">
            <span v-html="tab.title">{{tab.title}}</span>
          </span>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonTabNav',
  props: {
    tabs: Array
  },
  data () {
    return {
      currentTab: null,
            tabs2: [
        {
          id: 1,
          typeID: 1,
          cat: 'female',
          title: '<span class="color-pink"><literal> Male Actors </literal>',
          icon: require('@/assets/img/icon-male.svg'),
          active: false
        },
        {
          id: 2,
          typeID: 2,
          cat: 'male',
          title: '<span class="color-blue"><literal> Female Actors </literal>',
          icon: require('@/assets/img/icon-female.svg'),
          active: false
        }
      ]
    }
  },
  methods: {
    select (tab) {
      this.currentTab = tab
    },
    
    goPageAll(tab) {
     window.localStorage.setItem('list', 'university')
     window.localStorage.setItem('faculty_id', '')
     window.localStorage.setItem('faculty_name', '')
     window.localStorage.setItem('district_name', '')
     let route = { name: 'Person', params: { slug: this.$route.params.slug } }
/*       let gender = 'erkek'
      if(tab.typeID === 2 ) {
        gender = 'kiz'
      }
      let route = ''
      if (this.$route.params.faculty) {
       route = this.$route.params.slug + '--' + this.$route.params.faculty + '--' + gender + '-ogrenci-yurtlari/' 
      } else {
        route = this.$route.params.slug + '-yakin-' + gender + '-ogrenci-yurtlari/'
      } */
      this.$router.push(route)
    },    
    goPage(tab) {
      let gender = 'male'
      if(tab.typeID === 2 ) {
        gender = 'female'
        window.localStorage.setItem('gender_name', 'Male')
      } else {
        gender = 'male'
        window.localStorage.setItem('gender_name', 'Female')
      }
      let route = ''
        window.localStorage.setItem('typeID', tab.typeID)

      if (this.$route.params.distinct) {
      //  route = this.$route.params.slug + '--' + this.$route.params.faculty + '--' + gender + '-celebrities/'
      // route = { name: 'PersonDistinctGender', type: 1, gender: 1, distinct: tab.slug, params: { gender: 'female', distinct: tab.slug } }
        route = 'hollywood' + '-' + this.$route.params.distinct + '-' + gender + '-celebrities2/'
      } else {
        //route = this.$route.params.slug + '-p-' + gender + '-celebrities/'
        route = 'hollywood' + '-' + gender + '-celebrities/'
      }

      //this.$router.push('/' + route)
      route = { name: 'PersonGender', distinct: tab.slug, params: { person:'director', type:1, gender: 'female', distinct: tab.slug } }

      this.$router.push(route)
    },
    generateUrl (tab) {
      let route
      if (tab.typeID === 2) {
        if (this.$route.params.faculty) {
          route = { name: 'StudioProductGenre', params: { type: 'erkek' } }
        } else {
          route = { name: 'StudioProduct', params: { type: 'erkek' } }
        }
      } else if (tab.typeID === 1) {
        if (this.$route.params.faculty) {
          route = { name: 'StudioProductGenre', params: { type: 'kiz' } }
        } else {
          route = { name: 'StudioProduct', params: { type: 'kiz' } }
        }
      }
      return route
    },
    clearFilter () {
      // this.$router.push({ name: 'City', params: { slug: this.$route.params.slug } })
      this.currentTab = null
    }
  },
  computed: {
    checkGender () {
      let typeID
      if (this.$route.params.type === 'erkek') {
        typeID = 2
      } else if (this.$route.params.type === 'kiz') {
        typeID = 1
      }
      return typeID
    }
  }
}
</script>

<style scoped>
  .mycursorPointer { 
    cursor: pointer; 
    }
</style>
